import cn from 'classnames';
import { PropsWithChildren } from 'react';

interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  labelClassName?: string;
}

const Radio: React.FC<PropsWithChildren<Props>> = ({
  children,
  id,
  className,
  labelClassName,
  ...others
}) => {
  return (
    <>
      <input
        id={id}
        type="radio"
        className={cn(
          'cursor-pointer border-grey-300 bg-other-white text-text-secondary',
          className
        )}
        style={{
          accentColor: '#333333',
          height: '20px',
          width: '20px',
        }}
        {...others}
      />
      <label htmlFor={id} className={cn('cursor-pointer', labelClassName)}>
        {children}
      </label>
    </>
  );
};

export default Radio;
